import Notify from './notifyActions'
export const SET_PROFILE = 'SET_PROFILE'

export const setProfile = (profile) => {
  return {
    type: SET_PROFILE,
    profile: profile
  }
}

export const GET_PROFILE = 'GET_PROFILE';
export const getProfile = () => {
  return {
    type: GET_PROFILE
    // profile: {
    //   access_token: sessionStorage.getItem('access_token'),
    //   id_token: sessionStorage.getItem('id_token'),
    //   expires_at: sessionStorage.getItem('expiresAt'),
    //   profile: JSON.parse(sessionStorage.getItem('profile'))
    // }
  }
}

export const PASSWORD_CHANGE = 'PASSWORD_CHANGE'
export const PASSWORD_CHANGE_SUCCESSFULL_TOAST = 'password_change_successfull_toast'
export const passwordChange = (data) => {
  return (dispatch,getState) => {
    return new Promise((resolve,reject) => {
      dispatch({
        type: PASSWORD_CHANGE,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'changepassword',
            method: 'Post',
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(PASSWORD_CHANGE_SUCCESSFULL_TOAST))
          resolve();
        }else{
          reject(response.payload.data)
        }
      })
    })
  }
}

export const GET_DATA_REQUEST_SETTINGS = 'GET_DATA_REQUEST_SETTINGS'
export const getDataRequestSettings = () => {
  return dispatch => {
    return dispatch({
      type: GET_DATA_REQUEST_SETTINGS,
      payload: {
        request: {
          mode: 'no-cors',
          url: 'datarequest',
          method: 'GET'
        }
      }
    }).then(response => response.payload.data)
  }
}

export const SUBMIT_DATA_REQUEST = 'SUBMIT_DATA_REQUEST'
export const submitDataRequest = () => {
  return dispatch => {
    return dispatch({
      type: SUBMIT_DATA_REQUEST,
      payload: {
        request: {
          mode: 'no-cors',
          url: 'datarequest',
          method: 'POST'
        }
      }
    }).then(response => {
      const data = response.payload.data
      return data && data.success ? data : Promise.reject(data)
    })
  }
}
